import React, { useEffect, useState } from 'react'
import { Container, Grid, Typography, Box } from '@material-ui/core'
import { Timelapse } from '@material-ui/icons'
import CallToAction from 'components/CallToAction'
import './learn.scss'
import MakesBetter from 'components/MakesBetter'
import styled from '@emotion/styled'
import { mediaQueries } from 'devices'
import { useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { convertDate, convertMarkdownToText, readingTime } from './utils'
import QueryWrapper from 'components/querywrapper'
import { useFetchPage } from 'hooks'
import RedSquare from 'components/RedSquare'
import { useLocale } from 'hooks'
const { REACT_APP_STRAPI_API_URL } = process.env

// const relatedContents = [
//   {
//     title: 'Here’s a dummy title',
//     content:
//       'And a body copy that shouldn’t be too long and captures the first few lines of the article...',
//     image: Image6
//   },
//   {
//     title: 'Here’s a dummy title',
//     content:
//       'And a body copy that shouldn’t be too long and captures the first few lines of the article...',
//     image: Image7
//   },
//   {
//     title: 'Here’s a dummy title',
//     content:
//       'And a body copy that shouldn’t be too long and captures the first few lines of the article...',
//     image: Image8
//   }
// ]

const LearnArticle = () => {
  const { articleId } = useParams()
  const { locale } = useLocale()
  const [data, setData] = useState()

  const fetcher = () =>
    fetch(
      `${REACT_APP_STRAPI_API_URL}/api/articles/${articleId}?populate=*`
    ).then(res => res.json())
  const {
    data: fetchedData,
    isLoading: loading,
    isError: error
  } = useFetchPage(`api/learnarticle${articleId}`, fetcher)

  const getLocalizedData = () => {
    let localizedData
    fetchedData?.localizations?.data?.map(item => {
      if (item?.attributes?.locale === locale) {
        localizedData = item?.attributes
      }
    })
    if (localizedData) {
      setData(localizedData)
    } else {
      setData(fetchedData)
    }
  }

  useEffect(() => {
    getLocalizedData()
  }, [locale, fetchedData])

  return (
    <QueryWrapper loading={loading} error={error}>
      <Box sx={{ marginTop: '40px' }}>
        <ArticleHeader>
          <Container>
            <div className="content">
              <Grid item xs={12}>
                <div className="greataboutwrap">
                  <Typography variant="h1">{data?.title}</Typography>
                  <Box display="flex" alignItems="center">
                    <Typography variant="h4">
                      {convertDate(data?.createdAt)}
                    </Typography>
                    <Box
                      component="span"
                      display="flex"
                      alignItems="center"
                      sx={{ marginLeft: '31px' }}
                    >
                      <Timelapse
                        style={{
                          fill: '#FE9B10',
                          width: '16px',
                          height: '16px',
                          marginRight: '4px'
                        }}
                      />
                      <Typography variant="h4">
                        {readingTime(convertMarkdownToText(data?.content))}
                      </Typography>
                    </Box>
                  </Box>
                </div>
              </Grid>
            </div>
          </Container>
        </ArticleHeader>
      </Box>
      <Container>
        <ArticlContent>
          <div className="image-wrapper">
            <img
              src={
                REACT_APP_STRAPI_API_URL +
                fetchedData?.image?.data?.attributes.url
              }
            />
          </div>
          <ReactMarkdown
            transformImageUri={uri =>
              uri
                .toString()
                .replace('http://localhost:1337', REACT_APP_STRAPI_API_URL)
            }
          >
            {data?.content}
          </ReactMarkdown>
        </ArticlContent>
      </Container>
      {/* <Container>
            <H4Bold>Related content</H4Bold>
            <Grid
              style={{ display: 'flex', flexWrap: 'wrap', marginTop: '41px' }}
            >
              {relatedContents.map((item, index) => (
                <Grid
                  container
                  item
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  key={item}
                >
                  <div className="LearnCard">
                    <img src={item.image} alt=" " className="img-responsive" />
                    <div className="LearnDetail">
                      <Typography variant="h2">{item.title}</Typography>
                      <Typography component="p">{item.content}</Typography>
                      <Typography variant="h4">
                        22.07.2021{' '}
                        <span>
                          <Timelapse />
                          3m
                        </span>
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Container> */}
      <RedSquare />
      <section className="usBetter">
        <Container>
          <MakesBetter />
        </Container>
      </section>
      <section className="searchBnb">
        <Grid item xs={12}>
          <CallToAction />
        </Grid>
      </section>
    </QueryWrapper>
  )
}

export default LearnArticle

const ArticleHeader = styled.div`
  background: #5e17fe;
  padding: 70px 0px;
  margin-bottom: 40px;

  .content {
    max-width: 75%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    ${mediaQueries.phone} {
      width: 100%;
    }
  }
`

const ArticlContent = styled.div`
  max-width: 75%;
  margin: 0px auto;
  font-size: 20px;
  font-family: Roboto;
  margin-bottom: 141px;

  a {
    color: blue;
  }

  .image-wrapper {
    position: relative;
    padding-top: 50.25%;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }
  ${mediaQueries.phone} {
    max-width: 90%;
    ol {
      padding-left: 20px;
    }
    ul {
      padding-left: 20px;
    }
  }

  ul {
    li {
      margin-top: 10px;
    }
  }
`
